import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";

export default function ContentCalendar() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/articles?limit=200").then((r) => {
      const upcoming = r.data.items.filter((a) => a.publish_at && (a.status === "scheduled" || a.status === "published" || a.status === "draft_ready"));
      upcoming.sort((a, b) => new Date(a.publish_at) - new Date(b.publish_at));
      setItems(upcoming);
    });
  }, []);

  const grouped = items.reduce((acc, a) => {
    const d = new Date(a.publish_at).toLocaleDateString();
    acc[d] ||= [];
    acc[d].push(a);
    return acc;
  }, {});

  return (
    <div className="p-8 md:p-10">
      <div className="overline text-[#B4533C]">Calendar</div>
      <h1 className="font-serif text-4xl mt-1 mb-6">Content calendar</h1>
      {Object.keys(grouped).length === 0 && <div className="text-sm text-[#4A4742]">No scheduled content yet. Schedule an article from the editor.</div>}
      <div className="space-y-8">
        {Object.entries(grouped).map(([date, arts]) => (
          <div key={date}>
            <div className="overline text-[#1B3B36] mb-2">{date}</div>
            <div className="border border-[#D6CFC4]">
              {arts.map((a) => (
                <Link to={`/admin/articles/${a.id}`} key={a.id} className="flex justify-between items-center border-t first:border-t-0 border-[#D6CFC4] p-3 hover:bg-[#EFECE5]" data-testid={`cal-article-${a.id}`}>
                  <div>
                    <div className="text-sm font-medium">{a.title}</div>
                    <div className="text-xs font-mono text-[#4A4742]">{a.category} · {a.status}</div>
                  </div>
                  <div className="text-xs font-mono">{new Date(a.publish_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
